import "@shoelace-style/shoelace/dist/components/icon/icon.js";

import { css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { Style } from "../Styles";
import { IModification } from "../../backend/cloud/JournalTable";
import { ModificationAction } from "../../../models";
import { BaseElement } from "../BaseElement";

function actionToVerb(action: ModificationAction | keyof typeof ModificationAction) {
    switch (action) {
        case ModificationAction.CREATE:
            return "Created";
        case ModificationAction.DELETE:
            return "Deleted";
        case ModificationAction.UPDATE:
            return "Updated";
    }
    throw new Error(`Action ${action} not supported`);
}

@customElement("ds-journal-entry")
export class JournalEntry extends BaseElement {
    static override styles = [
        Style,
        css`
            .row {
                display: flex;
                flex-direction: row;
                align-items: center;
            }

            /*.card__header:hover {
                background-color: var(--sl-color-primary-50);
                color: var(--sl-color-primary-900);
            }*/

            .entry {
                display: flex;
                flex-direction: column;
                flex-grow: 1;
            }
            .model-id {
                font-size: 0.8em;
            }

            sl-icon {
                font-size: 1.5em;
            }

            .create {
                background-color: limegreen;
            }

            .update {
                background-color: palegoldenrod;
            }

            .delete {
                background-color: red;
            }

            .circle {
                width: 2em;
                height: 2em;
                border-radius: 1em;
                margin-right: 0.5em;
            }
        `,
    ];
    @property({ type: Object }) entry: IModification | undefined;

    override render() {
        return this.entry
            ? html`<div
                  class="row"
                  @click=${() =>
                      this._kernel.events.raiseEvent("ds-journal-entry-selected", this.entry)}
              >
                  <div class="circle ${this.entry ? this.entry.action.toLowerCase() : ""}"></div>
                  <div class="entry">
                      ${`${actionToVerb(this.entry.action)} ${this.entry.model} : ${
                          this.entry.modelName
                      }`}
                      <span class="model-id">${this.entry.modelId}</span>
                  </div>
                  <sl-icon name="eye"></sl-icon>
              </div>`
            : html``;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-journal-entry": JournalEntry;
    }
}
